import * as expressionNode from '../../node'
import type { Primitive } from '../primitive'

export function from<T extends Primitive>(val: T): expressionNode.Node<T> {
  return new expressionNode.ForValue(val)
}
